import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FormElementComponent } from '../form-inputs/components/form-element/form-element.component';
import { TRANSLOCO_SCOPE, TranslocoDirective } from '@jsverse/transloco';
import { LoaderComponent } from '../loader/loader.component';
import { customEmailValidator } from '../../validators/customEmailValidator';

@Component({
  selector: 'app-password-reset-form',
  imports: [CommonModule, ReactiveFormsModule, FormElementComponent, TranslocoDirective, RouterModule, LoaderComponent],
  templateUrl: './password-reset-form.component.html',
  styleUrl: './password-reset-form.component.css',
  standalone: true,
  providers: [{ provide: TRANSLOCO_SCOPE, useValue: 'auth' }]
})
export class PasswordResetFormComponent {
  @Input() isLoading = false;
  @Input() showBackButton = true;
  @Output() formSubmit = new EventEmitter<string>();

  public passwordForgottenForm: FormGroup;

  constructor() {
    this.passwordForgottenForm = new FormGroup({
      email: new FormControl('', {
        validators: [Validators.required, Validators.email, customEmailValidator()],
        updateOn: 'blur'
      })
    });
  }

  public onSubmit(): void {
    if (this.passwordForgottenForm.valid) {
      const email = this.passwordForgottenForm.value.email;
      this.formSubmit.emit(email);
    }
  }
}
